/**
 * @generated SignedSource<<aece0e3ca6233d57657cd5230a7702d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalDetailScreenRegisterAsSeenMutation$variables = {
  signalWorkspaceId: string;
};
export type SignalDetailScreenRegisterAsSeenMutation$data = {
  readonly signal: {
    readonly registerReceiverReceipt: {
      readonly id: string;
      readonly opened: boolean;
      readonly receiverReceipts: ReadonlyArray<{
        readonly openedAtDate: {
          readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
        };
        readonly signalWorkspaceId: string;
        readonly userId: string;
      }>;
      readonly receiverReceiptsCount: number;
    };
  };
};
export type SignalDetailScreenRegisterAsSeenMutation = {
  response: SignalDetailScreenRegisterAsSeenMutation$data;
  variables: SignalDetailScreenRegisterAsSeenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "signalWorkspaceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "signalWorkspaceId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opened",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signalWorkspaceId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "receiverReceiptsCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignalDetailScreenRegisterAsSeenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalMutation",
        "kind": "LinkedField",
        "name": "signal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Signal",
            "kind": "LinkedField",
            "name": "registerReceiverReceipt",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SignalReceiverReceipt",
                "kind": "LinkedField",
                "name": "receiverReceipts",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnzonedDate",
                    "kind": "LinkedField",
                    "name": "openedAtDate",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "FormattedDate"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignalDetailScreenRegisterAsSeenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalMutation",
        "kind": "LinkedField",
        "name": "signal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Signal",
            "kind": "LinkedField",
            "name": "registerReceiverReceipt",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SignalReceiverReceipt",
                "kind": "LinkedField",
                "name": "receiverReceipts",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnzonedDate",
                    "kind": "LinkedField",
                    "name": "openedAtDate",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isoString",
                            "storageKey": null
                          }
                        ],
                        "type": "Date",
                        "abstractKey": "__isDate"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cf8742d11717a2a1c99629a1033d4bab",
    "id": null,
    "metadata": {},
    "name": "SignalDetailScreenRegisterAsSeenMutation",
    "operationKind": "mutation",
    "text": "mutation SignalDetailScreenRegisterAsSeenMutation(\n  $signalWorkspaceId: ID!\n) {\n  signal(id: $signalWorkspaceId) {\n    registerReceiverReceipt {\n      id\n      opened\n      receiverReceipts {\n        signalWorkspaceId\n        userId\n        openedAtDate {\n          ...FormattedDate\n        }\n      }\n      receiverReceiptsCount\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "76985743b940045ed3f148972150b6e7";

export default node;
